
import { vietnameseTextToSlug } from "../utils/common";
export default {
  props: {
    customStyle: {
      type: Object,
    },
    thumb: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    location: {
      type: String,
      default: "",
    },
    id: {
      type: String | Number,
      default: "",
    },
    totalStudent: {
      type: String | Number,
      default: "",
    },
    cardStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
    };
  },
  methods: {
    getPath(id, title) {
      const test = vietnameseTextToSlug(title, id);

      return test;
    },
  },
};
